<template>
  <div class="part-child-orders-container">
    <part-child-orders-table v-if="onlyTable" :table-data="tableData"/>
    <div v-else class="default-table">
      <div class="form-rows">
        <div class="head">
          <div class="card-title" style="margin-top: 10px;">
            子订单信息 <i class="el-icon-refresh el-link el-link--primary" @click="getTableData"/>
          </div>
          <div>
            <append-child-orders v-permission="'can_append_child_puke'" :pid="pid" :project="project" @success="getTableData()"/>
            <el-tooltip class="item" effect="dark" content="释放子订单，变成独立订单" placement="top-end">
              <el-button v-show="userAuth.can_release_child_puke" type="primary" size="mini" @click="handelRelease">释放
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="转移子订单，至其他普客打包项目" placement="top-end">
              <el-button v-show="userAuth.can_transfer_child_puke" type="primary" size="mini" @click="handelTransfer">转移
              </el-button>
            </el-tooltip>
          </div>
        </div>
        <div style="padding: 0;">
          <part-child-orders-table ref="childOrdersTable" :table-data="tableData" can-radio/>
        </div>
      </div>
    </div>
    <transfer-child-orders :show.sync="dialogTransferOrder" :old-project="project" :origin-child-orders="tableData"
                        @success="getTableData"/>
    <release-child-orders :show.sync="dialogReleaseOrder" :order="ordersForRelease" :project="project"
                          @clearOrder="clearOrder"        @success="getTableData"/>
  </div>
</template>

<script>
import PartChildOrdersTable from "./PartChildOrdersTable";
import TransferChildOrders from "./TransferChildOrders";
import ReleaseChildOrders from "./ReleaseChildOrders.vue";
import AppendChildOrders from "@/views/adOrder/regular/components/AppendChildOrders";
import {getPukeOrderChild} from "@/api/regulars";

/**
 * 子订单信息
 */
export default {
  name: "PartChildOrders",
  components: {AppendChildOrders, PartChildOrdersTable, TransferChildOrders, ReleaseChildOrders},
  props: {
    pid: {
      type: [Number, String],
      required: true
    },
    project: {
      type: [Object],
      required: true
    },
    onlyTable: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      dialogTransferOrder: false,
      dialogReleaseOrder: false,
      tableData: [],
      ordersForTransfer: [],
      ordersForRelease: false,
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    },
  },
  created() {
    this.getTableData()
  },
  methods: {
    handelTransfer() {
      this.dialogTransferOrder = true;
    },
    handelRelease() {
      this.ordersForRelease = this.$refs.childOrdersTable.radioOrder || false
      if (!this.ordersForRelease) {
        this.$message.warning('请选择订单')
        return;
      }
      this.dialogReleaseOrder = true;
    },
    async getTableData() {
      this.tableData = [];
      let {data} = await getPukeOrderChild({pid:this.pid}).then(res => {
        return res.model
      })
      this.tableData = data ||[]
    },
    clearOrder(data){
      if(data){
        this.$refs.childOrdersTable.radioOrder=null
      }
    }
  }
}
</script>

<style lang="scss">
.part-child-orders-container {
  .head {
    display: flex;
    justify-content: space-between;
  }

  .form-rows {
    padding: 20px 40px !important;
  }

  .card-title {
    padding-left: 16px !important;
  }

  .card-title::after {
    left: 2px !important;
  }
}
</style>
